import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=83fead8a&scoped=true&"
import script from "./Shop.vue?vue&type=script&lang=ts&"
export * from "./Shop.vue?vue&type=script&lang=ts&"
import style0 from "./Shop.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Shop.vue?vue&type=style&index=1&id=83fead8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fead8a",
  null
  
)

export default component.exports